var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.content)?_c('section',{staticClass:"container container--small module-margin"},[_c('HtmlContent',{staticClass:"no-padding",attrs:{"html":_vm.data.content}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }